module.exports = ".app-form {\n    box-sizing: border-box;\n    width: 100%;\n    max-width: 800px;\n    margin: 0 auto;\n}"